import { isEmpty } from 'lodash';
import useFormValidation from './useFormValidation';
import useTransferSubresellerNewService from './useTransferSubresellerNewService';

export default function useForm() {
  const { handleSubmitTransferPartnerAsync } = useTransferSubresellerNewService();

  const {
    supportTicketAttributes,
    escalationTicketAttributes,
    descriptionAttributes,
    transferTypeAttributes,
    resellerIDToBeTransferredAttributes,
    targetDistributorIDAttributes,
    sourceDistributorIDAttributes,
    effectiveTrasferDateAttributes,
    targetOwnerAttributes,
    targetChannelAttributes,
    newPriceArchiverAttributes,
    newPriceBackupAttributes,
    newPriceQboAttributes,
    newPriceNfpArchiverAttributes,
    newPriceNfpBackupAttributes,
    newPriceArchiverEntraAttributes,
    newPriceBackupEntraAttributes,
    newPriceNfpArchiverEntraAttributes,
    newPriceNfpBackupEntraAttributes,
    targetCurrencyAttributes,
    billingTypeAttributes,
    wireTransferAttributes,
    paypalTypeAttributes,
    stripeTypeAttributes,
    confirmingTheAboveInfoAttributes,
    formData,
    formDataConfirmation,
    validateAll,
    validateAllConfirmation,
    isValid,
    isValidConfirmation,
    resetForm,
    resetFormConfirmation,
  } = useFormValidation();

  const onSubmit = async (e) => {
    e.preventDefault();
    const flag = await validateAllConfirmation();

    if (flag && confirmingTheAboveInfoAttributes.value) {
      // resetForm();
      // resetFormConfirmation();

      handleSubmitTransferPartnerAsync();
    }
  };

  return {
    supportTicketAttributes,
    escalationTicketAttributes,
    descriptionAttributes,
    transferTypeAttributes,
    resellerIDToBeTransferredAttributes,
    targetDistributorIDAttributes,
    sourceDistributorIDAttributes,
    effectiveTrasferDateAttributes,
    targetOwnerAttributes,
    targetChannelAttributes,
    newPriceArchiverAttributes,
    newPriceBackupAttributes,
    newPriceQboAttributes,
    newPriceNfpArchiverAttributes,
    newPriceNfpBackupAttributes,
    newPriceArchiverEntraAttributes,
    newPriceBackupEntraAttributes,
    newPriceNfpArchiverEntraAttributes,
    newPriceNfpBackupEntraAttributes,
    targetCurrencyAttributes,
    billingTypeAttributes,
    wireTransferAttributes,
    paypalTypeAttributes,
    stripeTypeAttributes,
    confirmingTheAboveInfoAttributes,
    formData,
    formDataConfirmation,
    validateAll,
    validateAllConfirmation,
    isValid,
    isValidConfirmation,
    resetForm,
    resetFormConfirmation,
    onSubmit,
  };
}
